import React from 'react'
import 'antd/dist/reset.css';
import { Route, Routes,} from 'react-router-dom'

//后端开发
import ProjectTabs from './backend/project/ProjectTabs'
//系统管理
import NotFoundPage from './sys/NotFoundPage'
//费用报销
import ExpenseAdd from './expense/expense/ExpenseAdd'
import ExpenseAddH5 from './expense/expense/ExpenseAddH5'
import ExpenseList from './expense/expense/ExpenseList'
//项目设计
import SketchProject from './sketch/project/SketchProject'
import ProjectDesc from './sketch/project/ProjectDesc'
import ClientDesc from './sketch/client/ClientDesc'
import SketchList from './sketch/sketch/SketchList'
import ModuleList from './sketch/module/ModuleList'
//齐当家
import QFirmList from './qidangjia/firm/QFirmList'
import FirmUserList from './qidangjia/firmUser/FirmUserList'

//
import AlbumGroup from './album/AlbumGroup'
import AlbumIndex from './album/AlbumIndex'
import AlbumGroupDetail from './album/AlbumGroupDetail'
import AlbumSection from './album/AlbumSection'
import AlbumPic from './album/AlbumPic'
import AlbumMan from './album/AlbumMan'
import AlbumStudentGroup from './lvdangjia/studentgroup/AlbumStudentGroup'
import AppList from './app/AppList'
import AppLimit from './app/AppLimit'
import AppSpec from './app/AppSpec'
import AppSet from './app/AppSet'
import ArapAdd from './finance/arap/ArapAdd'
import ArapAddOld from './finance/arap/ArapAddOld'
import ArapList from './finance/arap/ArapList'
import AppPower from './lvdangjia/power/AppPower'
import ArapStatementSend from './finance/arap/ArapStatementSend'
import ArapStatementReceive from './finance/arap/ArapStatementReceive'
import ArapStatementReceiveCover from './finance/arap/ArapStatementReceiveCover'
import ArapSumClient from './finance/arap/ArapSumClient'
import ArapSumClientType from './finance/arap/ArapSumClientType'
import ArapSumGoodsType from './finance/arap/ArapSumGoodsType'
import ArapSumGoods from './finance/arap/ArapSumGoods'
import ArapSumOperator from './finance/arap/ArapSumOperator'
import ArapSumSalesman from './finance/arap/ArapSumSalesman'
import ArapSumDept from './finance/arap/ArapSumDept'
import BalanceElseList from './finance/balance/BalanceElseList'
import BalanceTypeList from './finance/balance/BalanceTypeList'                            
import City from './gf/area/City'
import CityAdd from './gf/area/CityAdd'
import CityEdit from './gf/area/CityEdit'
import Clocking from './wage/Clocking'
import ClientList from './sell/client/ClientList'
import ContactList from './promote/wechat/ContactList'
import ContactListAddFriend from './promote/wechat/ContactListAddFriend'
import CommodityType from './gf/commodity/CommodityType'
import Country from './gf/area/Country'
import CountryAdd from './gf/area/CountryAdd'
import CountryEdit from './gf/area/CountryEdit'
import CourseAdd from './sell/teach/CourseAdd'
import CourseList from './sell/teach/CourseList'
import CourseTable from './sell/teach/CourseTable'      
import Destination from './gf/area/Destination'
import DestinationAdd from './gf/area/DestinationAdd'
import DestinationEdit from './gf/area/DestinationEdit'
import District from './gf/area/District'
import DistrictAdd from './gf/area/DistrictAdd'
import DistrictEdit from './gf/area/DistrictEdit'
import ElseIncome from './finance/else/ElseIncome'
import ElseIncomeSumType from './finance/else/ElseIncomeSumType'
import ElsePaid from './finance/else/ElsePaid'
import ElsePaidSumType from './finance/else/ElsePaidSumType'
import ElseSumClient from './finance/else/ElseSumClient'
import ElseSumDept from './finance/else/ElseSumDept'
import EvaluateIndex from './evaluate/EvaluateIndex'
import EvaluateGroup from './evaluate/EvaluateGroup'
import EvaluateGroupDetail from './evaluate/EvaluateGroupDetail'
import EvaluateGroupPoint from './evaluate/EvaluateGroupPoint'

import FeedbackList from './promote/feedback/FeedbackList'
import FeedbackTask from './promote/feedback/FeedbackTask'
import FirmAccount from './lvdangjia/firm/FirmAccount'
import FirmAdd from './qidangjia/firm/FirmAdd'
import FirmApp from './gf/firm/FirmApp'
import FirmList from './/lvdangjia/firm/FirmList'
import FirmOrder from './/lvdangjia/order/FirmOrder'

import FirmSumArap from './/lvdangjia/account/FirmSumArap'
import FirmSumBalance from './/lvdangjia/account/FirmSumBalance'
import FirmSumLedger from './/lvdangjia/account/FirmSumLedger'
import FirmSumTask from './gf/firm/FirmSumTask'
import FirmRecharge from './gf/firm/FirmRecharge'
import FirmTypeAdd from './qidangjia/firmType/FirmTypeAdd'
import FirmTypeQuery from './qidangjia/firmType/FirmTypeQuery'
import FirmTypeBalance from './gf/firm/FirmTypeBalance'
import FirmTypeGoods from './gf/firm/FirmTypeGoods'
import FirmUser from './gf/firm/FirmUser'
import FirmUserAdd from './qidangjia/firmUser/FirmUserAdd'

import FundAccount from './finance/fund/FundAccount'
import FundAdd from './finance/fund/FundAdd'
import FundList from './finance/fund/FundList'
import FundSumClient from './finance/fund/FundSumClient'
import FundSumClientType from './finance/fund/FundSumClientType'
import FundSumDept from './finance/fund/FundSumDept'
import FundSumGoods from './finance/fund/FundSumGoods'
import FundSumGoodsType from './finance/fund/FundSumGoodsType'
import FundSumOperator from './finance/fund/FundSumOperator'
import FundSumSalesman from './finance/fund/FundSumSalesman'
import GoodsAdd from './qidangjia/goods/GoodsAdd'
import GoodsCourseAdd from './qidangjia/goodsCourse/GoodsCourseAdd'
import GoodsCourseQuery from './qidangjia/goodsCourse/GoodsCourseQuery'
import GoodsOrderAdd from './qidangjia/goodsOrder/GoodsOrderAdd'
import GoodsOrderQuery from './qidangjia/goodsOrder/GoodsOrderQuery'
import GoodsQuery from './qidangjia/goods/GoodsQuery'
import GoodsSpecAdd from './qidangjia/goodsSpec/GoodsSpecAdd'
import GoodsSpecQuery from './qidangjia/goodsSpec/GoodsSpecQuery'
import GoodsTypeList from './finance/goods/GoodsTypeList'
import GuideIndex from './gf/guide/GuideIndex'
import GuideList from './gf/guide/GuideList'
import Landmark from './gf/area/Landmark'
import LandmarkAdd from './gf/area/LandmarkAdd'
import LandmarkEdit from './gf/area/LandmarkEdit'
import LoginGate from './cpn/LoginGate'
import Login from './sys/Login'
import H5sysLogin from './h5sys/H5sysLogin'
import H5sysLoginGate from './h5sys/H5sysLoginGate'
import H5sysHome from './h5sys/H5sysHome'
import H5sysGoodsList from './h5sys/goods/H5sysGoodsList'
import H5sysGoodsNewUser from './h5sys/goods/H5sysGoodsNewUser'
import MediaList from './promote/media/MediaList'
import MinePassword from './set/MinePassword'

import NewsAdd from './promote/news/NewsAdd'
import NewsList from './promote/news/NewsList'
import NewsTypeAdd from './promote/newsType/NewsTypeAdd'
import NewsTypeList from './promote/newsType/NewsTypeList'
// import NotFoundPage from './sys/NotFoundPage'
import PublishList from './promote/publish/PublishList'
import PublishTask from './promote/publish/PublishTask'
import PackageList from './promote/package/PackageList'
import Province from './gf/area/Province'
import ProvinceAdd from './gf/area/ProvinceAdd'
import ProvinceEdit from './gf/area/ProvinceEdit' 
import RequireAdd from './develop/require/RequireAdd'
import RequireTable from './develop/require/RequireTable'
import SetAppPayed from './set/SetAppPayed'
import SetAppLimits from './set/SetAppLimits'
import SetAppNotPay from './set/SetAppNotPay'
import SetCourse from './set/SetCourse'
import SetDept from './set/SetDept'
import SellIncome from './gf/sell/SellIncome'
import SetPost from './set/SetPost'
import SetRole from './set/SetRole'
import SetSubscription from './set/SetSubscription'
import SpecList from './develop/spec/SpecList'
import Street from './gf/area/Street'
import StreetAdd from './gf/area/StreetAdd'
import StreetEdit from './gf/area/StreetEdit'
import SysHome from './sys/SysHome'
import Task from './train/Task'
import TeachAdd from './sell/teach/TeachAdd'
import TaskAdd from './task/TaskAdd'
import TaskList from './task/TaskList'
import TeachList from './sell/teach/TeachList'
import TechDocList from './develop/techDoc/TechDocList'
import TradeAdd from './qidangjia/trade/TradeAdd'
import TradeQuery from './qidangjia/trade/TradeQuery'
import TrainCharge from './train/TrainCharge'
import TrainJoin from './train/TrainJoin'
import TrainLimits from './train/TrainLimits'
import TrainPlan from './train/TrainPlan'
import TrainQuestion from './train/TrainQuestion'
import TrainTask from './train/TrainTask'
import UploadH5 from './cpnH5/UploadH5'

import Wage from './wage/Wage'
import WageBank from './wage/WageBank'
import WageLimits from './wage/WageLimits'
import WageDetail from './wage/WageDetail'
import WebApply from './gf/web/WebApply'
import WebGoodsList from './sell/goods/WebGoodsList'
import WebGoodsSpecAdd from './sell/goodsSpec/WebGoodsSpecAdd'
import WebGoodsSpecList from './sell/goodsSpec/WebGoodsSpecList'
import WebGoodsOrderAdd from './sell/goodsOrder/WebGoodsOrderAdd'
import WebGoodsOrderList from './sell/goodsOrder/WebGoodsOrderList'
import WebGoodsTypeList from './sell/goodsType/WebGoodsTypeList'
import WorkWechatList from './promote/wechat/WorkWechatList'
import YwzBalanceList from './lvdangjia/balance/YwzBalanceList'
import YwzLedgerList from './lvdangjia/ledger/YwzLedgerList'

//前端
import WebHome from './front/WebHome'
import Service from './front/Service'
import SoftDesc from './front/SoftDesc'
import Dianshangtaizhang from './front/Dianshangtaizhang'
import WebAbout from './front/WebAbout'
import WebGoods from './front/WebGoods'
import WebNews from './front/WebNews'
import WebGoodsSubTypeGoodsDesc from './front/WebGoodsSubTypeGoodsDesc' 
//定制开发
import FrontSketchProject from './front/FrontSketchProject'
import FrontSketchClient from './front/FrontSketchClient'
import SketchLogs from './front/SketchLogs'
import Xiaofeng from './front/Xiaofeng'
import HomeH5 from './frontH5/HomeH5'
import H5Index from './frontH5/H5Index'
import H5Service from './frontH5/Service'
import H5SoftDesc from './frontH5/SoftDesc'
import H5Dianshangtaizhang from './frontH5/Dianshangtaizhang'
import H5WebAbout from './frontH5/WebAbout'
import H5WebGoods from './frontH5/WebGoods'
import H5WebNews from './frontH5/WebNews'
import H5FrontSketchProject from './frontH5/FrontSketchProject'
import H5FrontSketchClient from './frontH5/FrontSketchClient'
import H5SketchLogs from './frontH5/SketchLogs'
import H5Xiaofeng from './frontH5/Xiaofeng'
import TransferBuy from './front/TransferBuy'
import FirmLogin from './firm/FirmLogin'
import FirmRegister from './firm/FirmRegister'
import FirmOrderList from './firm/FirmOrderList'
import FirmLoginGate from './firm/FirmLoginGate'
import FirmHome from './firm/FirmHome'
import FirmPassword from './firm/FirmPassword'  
//演示
import DemoIndex from './demo/DemoIndex'
function App() {    
    // function isMobile() {
    //     return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    //         || window.innerWidth <= 768
    // }
    
    // function HomeRedirect() {
    //     const navigate = useNavigate()
    //     useEffect(() => {
    //         if (isMobile()) {
    //             navigate('/HomeH5', { replace: true })
    //         } else {
    //             navigate('/WebHome', { replace: true })
    //         }
    //     }, [navigate])
    //     return null
    // }
      
    return (    
        <Routes>        
            
            <Route path='/ArapStatementReceiveCover' element={<ArapStatementReceiveCover />}></Route>   
            <Route path='/Login' element={<Login />}></Route>   
            <Route path='/H5sysLogin' element={<H5sysLogin />}></Route>
            <Route element={<H5sysLoginGate />}>
                <Route path='/H5sysHome' element={<H5sysHome />}></Route>
                <Route path='/H5sysGoodsList' element={<H5sysGoodsList />}></Route>
                <Route path='/H5sysGoodsNewUser' element={<H5sysGoodsNewUser />}></Route>
            </Route>
            <Route path='/UploadH5' element={<UploadH5 />}></Route>   
             {/* 前端 */}
            <Route path='/' element={<WebHome />}></Route>                             
            <Route path='Service' element={<Service />}></Route>                          
            <Route path='SoftDesc' element={<SoftDesc />}></Route>                          
            <Route path='Dianshangtaizhang' element={<Dianshangtaizhang />}></Route>                          
            <Route path='WebAbout' element={<WebAbout />}></Route>      
            <Route path='WebGoods' element={<WebGoods />}></Route>    
            <Route path='WebNews' element={<WebNews />}></Route>    
               
            <Route path='TransferBuy' element={<TransferBuy />}></Route>    
            <Route path='FirmLogin' element={<FirmLogin />}></Route>    
            <Route path='FirmRegister' element={<FirmRegister />}></Route>    
            <Route element={<FirmLoginGate />}>
                <Route path='FirmOrderList' element={<FirmOrderList />}></Route>    
                <Route path='FirmHome' element={<FirmHome />}></Route>    
                <Route path='FirmPassword' element={<FirmPassword />}></Route>
                <Route path='WebGoodsSubTypeGoodsDesc' element={<WebGoodsSubTypeGoodsDesc />}></Route>   
                <Route path='/DemoIndex' element={<DemoIndex />}></Route>     
            </Route>
            {/* 定制开发 */}
            <Route path='FrontSketchProject' element={<FrontSketchProject />}></Route>    
            <Route path='FrontSketchClient' element={<FrontSketchClient />}></Route>    
            <Route path='FrontSketchLogs' element={<SketchLogs />}></Route>    
            {/* H5手机端 */}
            <Route path='Xiaofeng' element={<Xiaofeng />}></Route>    
            <Route path='HomeH5' element={<HomeH5 />}></Route>
            <Route path='H5Index' element={<H5Index />}></Route>
            <Route path='H5Service' element={<H5Service />}></Route>
            <Route path='H5SoftDesc' element={<H5SoftDesc />}></Route>
            <Route path='H5Dianshangtaizhang' element={<H5Dianshangtaizhang />}></Route>
            <Route path='H5WebAbout' element={<H5WebAbout />}></Route>
            <Route path='H5WebGoods' element={<H5WebGoods />}></Route>
            <Route path='H5WebNews' element={<H5WebNews />}></Route>
            <Route path='H5SketchProject' element={<H5FrontSketchProject />}></Route>
            <Route path='H5SketchClient' element={<H5FrontSketchClient />}></Route>
            <Route path='H5SketchLogs' element={<H5SketchLogs />}></Route>
            <Route path='H5Xiaofeng' element={<H5Xiaofeng />}></Route>
            {/* 后台 */}
            <Route path='/SysHome' element={<LoginGate />}>
                <Route path='/SysHome' element={<SysHome />}></Route>  
                {/* 后端开发                */}                
                <Route path='/SysHome/ProjectTabs' element={<ProjectTabs />}></Route>  
                {/* 需求设计 */}
                <Route path='/SysHome/SketchProject' element={<SketchProject />} />
                <Route path='/SysHome/Projectdesc' element={<ProjectDesc />} />
                <Route path='/SysHome/Userdesc' element={<ClientDesc />} />
                <Route path='/SysHome/SketchList' element={<SketchList />} />
                <Route path='/SysHome/ModuleList' element={<ModuleList />} />
                {/* 齐当家 */}
                <Route path='/SysHome/QFirmList' element={<QFirmList />} />                 
                <Route path='/SysHome/FirmUserList' element={<FirmUserList />}></Route>   
                {/* 推广 */}
                <Route path='/SysHome/ContactList' element={<ContactList />}></Route>   
                <Route path='/SysHome/ContactListAddFriend' element={<ContactListAddFriend />}></Route>   
                <Route path='/SysHome/WorkWechatList' element={<WorkWechatList />}></Route>     
                {/* 旧路由 */}
                <Route path='/SysHome/AlbumGroup' element={<AlbumGroup />}></Route>
                <Route path='/SysHome/AlbumIndex' element={<AlbumIndex />}></Route>        
                <Route path='/SysHome/AlbumGroupDetail' element={<AlbumGroupDetail />}></Route>
                <Route path='/SysHome/AlbumSection' element={<AlbumSection />}></Route>
                <Route path='/SysHome/AlbumPic' element={<AlbumPic />}></Route>
                <Route path='/SysHome/AlbumMan' element={<AlbumMan />}></Route>
                <Route path='/SysHome/AlbumStudentGroup' element={<AlbumStudentGroup />}></Route>
                <Route path='/SysHome/AppList' element={<AppList />}></Route>
                <Route path='/SysHome/AppLimit' element={<AppLimit />}></Route>
                <Route path='/SysHome/AppSpec' element={<AppSpec />}></Route>
                <Route path='/SysHome/AppSet' element={<AppSet />}></Route>            
                <Route path='/SysHome/ArapAdd' element={<ArapAdd />}></Route>
                <Route path='/SysHome/ArapAddOld' element={<ArapAddOld />}></Route>
                <Route path='/SysHome/ArapList' element={<ArapList />}></Route>
                <Route path='/SysHome/ArapStatementSend' element={<ArapStatementSend />}></Route>
                <Route path='/SysHome/ArapStatementReceive' element={<ArapStatementReceive />}></Route>
                <Route path='/SysHome/ArapSumClient' element={<ArapSumClient />}></Route> 
                <Route path='/SysHome/ArapSumClientType' element={<ArapSumClientType />}></Route> 
                <Route path='/SysHome/ArapSumDept' element={<ArapSumDept />}></Route>             
                <Route path='/SysHome/ArapSumGoods' element={<ArapSumGoods />}></Route> 
                <Route path='/SysHome/ArapSumGoodsType' element={<ArapSumGoodsType />}></Route> 
                <Route path='/SysHome/ArapSumOperator' element={<ArapSumOperator />}></Route> 
                <Route path='/SysHome/ArapSumSalesman' element={<ArapSumSalesman />}></Route> 
                <Route path='/SysHome/AppPower' element={<AppPower />}></Route>
                <Route path='/SysHome/BalanceElseList' element={<BalanceElseList />}></Route>
                <Route path='/SysHome/BalanceTypeList' element={<BalanceTypeList />}></Route>
                <Route path='/SysHome/City' element={<City />} />
                <Route path='/SysHome/CityAdd' element={<CityAdd/>} />
                <Route path='/SysHome/CityEdit/:id' element={<CityEdit />} />
                <Route path='/SysHome/ClientList' element={<ClientList />}></Route>   
                <Route path='/SysHome/CommodityType' element={<CommodityType />}></Route>
                <Route path='/SysHome/Country' element={<Country />} />
                <Route path='/SysHome/CountryAdd' element={<CountryAdd/>} />
                <Route path='/SysHome/CountryEdit/:id' element={<CountryEdit />} />                
                <Route path='/SysHome/CourseAdd' element={<CourseAdd />} />                
                <Route path='/SysHome/CourseList' element={<CourseList />} />                
                <Route path='/SysHome/CourseTable' element={<CourseTable />} />                
                <Route path='/SysHome/Destination' element={<Destination />} /> 
                <Route path='/SysHome/DestinationAdd' element={<DestinationAdd />} /> 
                <Route path='/SysHome/DestinationEdit' element={<DestinationEdit />} />        
                <Route path='/SysHome/District' element={<District />} />
                <Route path='/SysHome/DistrictAdd' element={<DistrictAdd/>} />
                <Route path='/SysHome/DistrictEdit/:id' element={<DistrictEdit />} />    
                <Route path='/SysHome/ElseIncome' element={<ElseIncome />}></Route>
                <Route path='/SysHome/ElseIncomeSumType' element={<ElseIncomeSumType />}></Route>
                <Route path='/SysHome/ElsePaid' element={<ElsePaid />}></Route>    
                <Route path='/SysHome/ElsePaidSumType' element={<ElsePaidSumType />}></Route>    
                <Route path='/SysHome/ElseSumClient' element={<ElseSumClient />}></Route>    
                <Route path='/SysHome/ElseSumDept' element={<ElseSumDept />}></Route>    
                <Route path='/SysHome/EvaluateIndex' element={<EvaluateIndex />}></Route>
                <Route path='/SysHome/EvaluateGroup' element={<EvaluateGroup />}></Route>
                <Route path='/SysHome/EvaluateGroupDetail' element={<EvaluateGroupDetail />}></Route>
                <Route path='/SysHome/EvaluateGroupPoint' element={<EvaluateGroupPoint />}></Route>
                <Route path='/SysHome/ExpenseAdd' element={<ExpenseAdd />}></Route>
                <Route path='/SysHome/ExpenseAddH5' element={<ExpenseAddH5 />}></Route>
                <Route path='/SysHome/ExpenseList' element={<ExpenseList />}></Route>
                <Route path='/SysHome/FeedbackList' element={<FeedbackList />}></Route>    
                <Route path='/SysHome/FeedbackTask' element={<FeedbackTask />}></Route>    
                <Route path='/SysHome/FirmAccount' element={<FirmAccount />}></Route>    
                <Route path='/SysHome/FirmAdd' element={<FirmAdd />}></Route>    
                <Route path='/SysHome/FirmApp' element={<FirmApp />}></Route>    
                <Route path='/SysHome/FirmList' element={<FirmList />}></Route>
                <Route path='/SysHome/FirmOrder' element={<FirmOrder />}></Route>        
                <Route path='/SysHome/FirmRecharge' element={<FirmRecharge />}></Route>   
                <Route path='/SysHome/FirmSumArap' element={<FirmSumArap />}></Route>
                <Route path='/SysHome/FirmSumBalance' element={<FirmSumBalance />}></Route>
                <Route path='/SysHome/FirmSumLedger' element={<FirmSumLedger />}></Route>
                <Route path='/SysHome/FirmSumTask' element={<FirmSumTask />}></Route>
                <Route path='/SysHome/FirmTypeAdd' element={<FirmTypeAdd />}></Route>
                <Route path='/SysHome/FirmTypeQuery' element={<FirmTypeQuery />}></Route>
                <Route path='/SysHome/FirmTypeBalance' element={<FirmTypeBalance />}></Route>
                <Route path='/SysHome/FirmTypeGoods' element={<FirmTypeGoods />}></Route> 
                <Route path='/SysHome/FirmUser' element={<FirmUser />}></Route>        
                <Route path='/SysHome/FirmUserAdd' element={<FirmUserAdd />}></Route>            
                <Route path='/SysHome/FundAccount' element={<FundAccount />}></Route>
                <Route path='/SysHome/FundAdd' element={<FundAdd />}></Route>        
                <Route path='/SysHome/FundList' element={<FundList />}></Route>        
                <Route path='/SysHome/FundSumClient' element={<FundSumClient />}></Route>        
                <Route path='/SysHome/FundSumClientType' element={<FundSumClientType />}></Route>        
                <Route path='/SysHome/FundSumDept' element={<FundSumDept />}></Route>        
                <Route path='/SysHome/FundSumGoods' element={<FundSumGoods />}></Route>        
                <Route path='/SysHome/FundSumGoodsType' element={<FundSumGoodsType />}></Route>        
                <Route path='/SysHome/FundSumOperator' element={<FundSumOperator />}></Route>        
                <Route path='/SysHome/FundSumSalesman' element={<FundSumSalesman />}></Route>                 
                <Route path='/SysHome/GoodsAdd' element={<GoodsAdd />}></Route>         
                <Route path='/SysHome/GoodsCourseAdd' element={<GoodsCourseAdd />}></Route>         
                <Route path='/SysHome/GoodsCourseQuery' element={<GoodsCourseQuery />}></Route>         
                <Route path='/SysHome/GoodsOrderAdd' element={<GoodsOrderAdd />}></Route>         
                <Route path='/SysHome/GoodsOrderQuery' element={<GoodsOrderQuery />}></Route>         
                <Route path='/SysHome/GoodsQuery' element={<GoodsQuery />}></Route>         
                <Route path='/SysHome/GoodsSpecAdd' element={<GoodsSpecAdd />}></Route>         
                <Route path='/SysHome/GoodsSpecQuery' element={<GoodsSpecQuery />}></Route>         
                <Route path='/SysHome/GoodsTypeList' element={<GoodsTypeList />}></Route>         
                <Route path='/SysHome/GuideIndex' element={<GuideIndex />}></Route>
                <Route path='/SysHome/GuideList' element={<GuideList />}></Route>
                <Route path='/SysHome/Landmark' element={<Landmark />} /> 
                <Route path='/SysHome/LandmarkAdd' element={<LandmarkAdd />} /> 
                <Route path='/SysHome/LandmarkEdit' element={<LandmarkEdit />} />     
                <Route path='/SysHome/NewsAdd' element={<NewsAdd />}></Route>
                <Route path='/SysHome/NewsList' element={<NewsList />}></Route>
                <Route path='/SysHome/NewsTypeAdd' element={<NewsTypeAdd />}></Route>
                <Route path='/SysHome/NewsTypeList' element={<NewsTypeList />}></Route>
                <Route path='/SysHome/MediaList' element={<MediaList />}></Route>
                <Route path='/SysHome/MinePassword' element={<MinePassword />}></Route>
                <Route path='/SysHome/PublishList' element={<PublishList />}></Route>
                <Route path='/SysHome/PublishTask' element={<PublishTask />}></Route>
                <Route path='/SysHome/PackageList' element={<PackageList />} />
                <Route path='/SysHome/Province' element={<Province />} />
                <Route path='/SysHome/ProvinceAdd' element={<ProvinceAdd/>} />
                <Route path='/SysHome/ProvinceEdit/:id' element={<ProvinceEdit />} />
                <Route path='/SysHome/RequireAdd' element={<RequireAdd />}></Route>
                <Route path='/SysHome/RequireTable' element={<RequireTable />}></Route>
                <Route path='/SysHome/SellIncome' element={<SellIncome />}></Route>   
                <Route path='/SysHome/SetAppNotPay' element={<SetAppNotPay />}></Route>
                <Route path='/SysHome/SetAppPayed' element={<SetAppPayed />}></Route>        
                <Route path='/SysHome/SetAppLimits' element={<SetAppLimits />}></Route>         
                <Route path='/SysHome/SetCourse' element={<SetCourse />}></Route>
                <Route path='/SysHome/SetDept' element={<SetDept />}></Route>           
                <Route path='/SysHome/SetPost' element={<SetPost />}></Route>
                <Route path='/SysHome/SetRole' element={<SetRole />}></Route>
                <Route path='/SysHome/SetSubscription' element={<SetSubscription />}></Route>
                <Route path='/SysHome/SpecList' element={<SpecList />}></Route>
                <Route path='/SysHome/Street' element={<Street />} />
                <Route path='/SysHome/StreetAdd' element={<StreetAdd/>} />
                <Route path='/SysHome/StreetEdit/:id' element={<StreetEdit />} />    
                <Route path='/SysHome/Task' element={<Task />}></Route>
                <Route path='/SysHome/TeachAdd' element={<TeachAdd />} />
                <Route path='/SysHome/TeachList' element={<TeachList />} />
                <Route path='/SysHome/TaskAdd' element={<TaskAdd />} />
                <Route path='/SysHome/TaskList' element={<TaskList />} />
                <Route path='/SysHome/TechDocList' element={<TechDocList />}></Route>
                <Route path='/SysHome/TradeAdd' element={<TradeAdd />}></Route>
                <Route path='/SysHome/TradeQuery' element={<TradeQuery />}></Route>
                <Route path='/SysHome/TrainCharge' element={<TrainCharge />}></Route>
                <Route path='/SysHome/TrainJoin' element={<TrainJoin />}></Route>
                <Route path='/SysHome/TrainLimits' element={<TrainLimits />}></Route>            
                <Route path='/SysHome/TrainPlan' element={<TrainPlan />}></Route>
                <Route path='/SysHome/TrainQuestion' element={<TrainQuestion />}></Route>                
                <Route path='/SysHome/TrainTask' element={<TrainTask />}></Route>
                <Route path='/SysHome/Wage' element={<Wage />}></Route>
                <Route path='/SysHome/WageBank' element={<WageBank />}></Route>
                <Route path='/SysHome/WageLimits' element={<WageLimits />}></Route>
                <Route path='/SysHome/WageDetail' element={<WageDetail />}></Route>
                <Route path='/SysHome/Clocking' element={<Clocking />}></Route>                              
                <Route path='/SysHome/WebApply' element={<WebApply />}></Route>  
                <Route path='/SysHome/WebGoodsList' element={<WebGoodsList />}></Route>
                <Route path='/SysHome/WebGoodsOrderAdd' element={<WebGoodsOrderAdd />}></Route>
                <Route path='/SysHome/WebGoodsOrderList' element={<WebGoodsOrderList />}></Route>
                <Route path='/SysHome/WebGoodsSpecAdd' element={<WebGoodsSpecAdd />}></Route>
                <Route path='/SysHome/WebGoodsSpecList' element={<WebGoodsSpecList />}></Route>          
                <Route path='/SysHome/WebGoodsTypeList' element={<WebGoodsTypeList />}></Route>          
                <Route path='/SysHome/YwzBalanceList' element={<YwzBalanceList />}></Route>          
                <Route path='/SysHome/YwzLedgerList' element={<YwzLedgerList />}></Route>
            </Route>
            
            <Route path="*" element={<NotFoundPage/>} />
        </Routes>   
    )
}

export default App